// Select de colaborador CLT (espelho, filtro e "Criar ajuste"). O menu com o e-mail
// e a busca vêm do @components/OptionWithHint.

/** Contratos CLT (`listCltContracts`) → opções do Select, com o id do contrato no value. */
export const employeeOptionsOf = (contracts) =>
  contracts.map((contract) => ({
    value: String(contract.id),
    label: contract.contractor?.name || `Contrato #${contract.id}`,
    hint: contract.contractor?.email || "",
  }));
